// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3MeBF","error":"Textarea_error__2zzxg","readonly":"Textarea_readonly__bjuOq","disabled":"Textarea_disabled__144W4"};